import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import { categories } from "@/mocks/site";

const rankMedals = ["text-primary-600 bg-primary-100", "text-accent-700 bg-accent-100", "text-secondary-700 bg-secondary-100"];

export default function RadarSection() {
  const ranked = [...events].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const total = events.reduce((s, e) => s + e.heat, 0);

  const catStats = categories.map((c) => {
    const list = events.filter((e) => e.catId === c.id);
    return { ...c, count: list.length, heat: list.reduce((s, e) => s + e.heat, 0) };
  });

  return (
    <section id="radar" className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-700">
              <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-accent-500" />
              Gua Point Radar
            </p>
            <h2 className="mt-2 font-display text-2xl font-black text-foreground-950 md:text-4xl">
              瓜点雷达 · 热度榜
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              按讨论热度与在场人数实时排序，把最值得下嘴的大瓜放在最前面。
            </p>
          </div>
          <Link to="/#gua" className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer">
            看完整瓜单
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* ranking list */}
          <div className="lg:col-span-8">
            <ol className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {ranked.map((e, i) => (
                <li key={e.id}>
                  <Link to={`/gua/${e.id}`} className="group flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5 cursor-pointer">
                    <span
                      className={`font-display flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-lg font-black ${
                        rankMedals[i] || "bg-background-100 text-foreground-400"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
                        {e.title}
                      </h3>
                      <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1"><i className="ri-folder-line text-accent-600" />{e.catName}</span>
                        <span className="inline-flex items-center gap-1"><i className="ri-user-3-line text-accent-600" />{e.crowd} 在场</span>
                        <span>更新 {e.updated}</span>
                      </div>
                    </div>
                    <div className="hidden w-28 shrink-0 sm:block">
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-foreground-400">热度</span>
                        <b className="text-foreground-900">{e.heat}</b>
                      </div>
                      <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                        <div className="h-full rounded-full bg-gradient-to-r from-accent-400 to-accent-600" style={{ width: `${e.heat}%` }} />
                      </div>
                    </div>
                    <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-600" />
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          {/* category distribution */}
          <aside className="lg:col-span-4" aria-label="吃瓜专区分布">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-display text-base font-bold text-foreground-950">吃瓜专区分布</h3>
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">本日瓜单 {events.length} 条</span>
              </div>
              <ul className="mt-5 space-y-4">
                {catStats.map((c) => {
                  const pct = total ? Math.round((c.heat / total) * 100) : 0;
                  return (
                    <li key={c.id}>
                      <div className="flex items-center justify-between text-sm">
                        <span className="inline-flex items-center gap-2 text-foreground-800">
                          <i className={`${c.icon} text-accent-600`} />
                          {c.name}
                        </span>
                        <span className="text-xs text-foreground-500">{c.count} 条 · {pct}%</span>
                      </div>
                      <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-background-200">
                        <div className="h-full rounded-full bg-accent-500/80" style={{ width: `${pct}%` }} />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="mt-4 flex items-center gap-3 rounded-2xl bg-foreground-950 px-5 py-4">
              <i className="ri-fire-fill text-2xl text-primary-500" />
              <div>
                <p className="text-xs text-background-200">本日最热大瓜</p>
                <p className="font-display text-lg font-bold text-background-50">
                  {ranked[0]?.catName}·热度 {ranked[0]?.heat}
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}